<template>
  <v-container>
    <v-layout>
      <v-flex>
        <v-text-field
          v-model="searchValue"
          label="搜尋"
          :color="Theme.GREEN"
          placeholder="查詢櫃位"
        ></v-text-field>
      </v-flex>
      <v-flex>
        <v-btn
          class="mr-2"
          :color="Theme.GREEN"
          dark
          @click.prevent="searchEvent"
          >搜尋</v-btn
        >
        <v-btn :color="Theme.YELLOW" dark @click.prevent="reset">重置</v-btn>
      </v-flex>
      <v-flex>
        <v-spacer></v-spacer>
        <v-btn
          style="float: right;"
          :color="Theme.PINK"
          dark
          @click.prevent="addNew"
          >新增</v-btn
        >
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex>
        <table-view
          :items="list"
          :columnKeys="getColumnKeys"
          :pagination="pagination"
          :loading="loading"
          @changePage="changePage"
          @cellEvent="cellEvent"
        />
      </v-flex>
    </v-layout>

    <counter-detail
      :title="editView.title"
      :visible="editView.visible"
      :item-detail="editView.item"
      :show-cancel="editView.showCancel"
      @cancelEvent="editView.cancelEvent"
      @confirmEvent="editView.confirmEvent"
    />
  </v-container>
</template>

<script>
import TableView from "@/components/TableView";
import CounterDetail from "./CounterDetail";
import { mapGetters, mapActions } from "vuex";
import common from "@/mixins/common";

export default {
  name: "product",
  components: {
    TableView,
    CounterDetail,
  },
  mixins: [common],
  data() {
    return {
      loading: false,
      searchValue: "",
      pagination: {
        page: 1,
        itemsPerPage: 10,
        totalItems: 0,
      },
      list: [],
      editView: {
        visible: false,
        item: null,
        showCancel: true,
        confirmEvent: () => {},
        cancelEvent: () => {},
      },
    };
  },
  created() {
    this.loadData();
  },
  computed: {
    ...mapGetters([]),
    getColumnKeys() {
      return [
        {
          value: "edit",
          text: "編輯",
          isEvent: true,
          color: this.Theme.GREEN,
          sortable: false,
        },
        { value: "counterId", text: "ID", sortable: true },
        { value: "name", text: "櫃位", sortable: true },
        {
          value: "enable",
          text: "櫃位狀態",
          sortable: false,
          options: this.getCounterEnable,
        },
      ];
    },
  },
  methods: {
    ...mapActions(["getCounterList"]),
    async loadData() {
      try {
        this.loading = true;
        const res = await this.getCounterList();
        console.log(`res ${JSON.stringify(res)}`);
        if (res.data.code === 0) {
          this.list = res.data.body;
          this.pagination.totalItems = res.data.body.lenght;

          console.log(`getCounterList ${JSON.stringify(res.data.body)}`);
        }
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
    /**
     * 頁面切換
     * @param page Object - { page: 頁數, itemsPerPage: 每頁幾筆 }
     * */
    changePage(page) {
      this.pagination.page = page.page;
      if (page.itemsPerPage === -1) {
        this.pagination.itemsPerPage = 1000;
      } else {
        this.pagination.itemsPerPage = page.itemsPerPage;
      }
      console.log(`changePage ${JSON.stringify(this.pagination)}`);
      this.loadData();
    },
    /**
     * 列表按鈕點擊事件
     * @param cell Object - { key: 事件代碼, item: 物件 }
     * */
    cellEvent(cell) {
      console.log(`cellEvent ${cell.key} ${JSON.stringify(cell.item)}`);
      if (!cell.item.imageList) {
        cell.item.imageList = [];
      }
      if (!cell.item.linkList) {
        cell.item.linkList = [];
      }

      this.editView.title = cell.key === "add" ? "新增櫃位" : "修改櫃位";
      this.editView.item = cell.item;
      this.editView.visible = true;
      this.editView.cancelEvent = () => {
        this.editView.visible = false;
      };
      this.editView.confirmEvent = () => {
        this.editView.visible = false;
        this.loadData();
      };
    },
    searchEvent() {
      this.loadData();
    },
    reset() {
      this.searchValue = "";
      this.loadData();
    },
    addNew() {
      this.cellEvent({
        key: "add",
        item: {
          counterId: "",
          name: "",
          enable: true,
        },
      });
    },
  },
};
</script>

<style scoped></style>
